<template>
    <div class="layout">
        <top-bar></top-bar>
        <side-bar></side-bar>
        <bread-crumb :breadcrumbList="breadcrumbList"></bread-crumb>
        <router-view class="container" @breadcrumbChange="breadcrumbChange"></router-view>
    </div>
</template>
<script>
    import topBar from '../components/Topbar'
    import breadCrumb from '../components/BreadCrumb';
    import sideBar from '../components/SideBar'
    export default {
        data() {
            return {
                breadcrumbList:[],
            }
        },
        methods:{
            breadcrumbChange(val){
                this.breadcrumbList=val;
            },
        },
        components:{
            topBar,
            sideBar,
            breadCrumb
        }
    }
</script>
<style lang="less">
    div.layout{
        >div.container{
            min-width:1080px;
        }
    .ant-pagination{
        float: right;
        margin-right: 20px;
        margin-top: 20px;
    }
        div.bread-box{
            margin-top:90px;
        }
    }
</style>